import { useTranslation } from "@redotech/redo-i18n";
import { TrackableType } from "@redotech/redo-order-tracking-trackable-common/trackable";
import { TrackingTypeState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoRadioGroup } from "@redotech/redo-web/arbiter-components/radio/redo-radio-group";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const TrackingTypeDetails = memo(function TrackingTypeDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<TrackingTypeState>) {
  const { t } = useTranslation();
  return (
    <Flex dir="column" gap="xs">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        {t("Tracking type")}
      </Text>
      <RedoRadioGroup<TrackableType>
        disabled={disabled}
        options={[
          { id: TrackableType.ORDER, label: t("Order") },
          { id: TrackableType.RETURN, label: t("Return") },
        ]}
        setValue={setState}
        value={state as TrackableType}
      />
      <Text fontSize="xxs" fontWeight="regular" textColor="secondary">
        {t(
          "Select the type of tracking page you'd like this condition to apply to",
        )}
      </Text>
    </Flex>
  );
});
